import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  background: linear-gradient(
    108deg,
    rgba(3, 169, 244, 1) 0%,
    rgba(0, 68, 119, 1) 100%
  );
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  max-width: 100%;
  overflow-x: clip; /* prevent horizontal scroll */

  ${(props) =>
    props.isFilterActive &&
    `
    background-color: rgba(0, 0, 0, 0.5);
    filter: grayscale(100%);
  `}

  @media screen and (max-width: 768px) {
    padding: 60px 10px;
  }
  @media screen and (max-width: 480px) {
    padding: 60px 10px;
  }
`;

export const FromWrap = styled.div`
  width: 100%;
  max-width: 920px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
`;

export const Icon = styled(Link)`
  margin-left: 32px;
  margin-top: 32px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 32px;

  @media screen and (max-width: 480px) { /* fixed typo */
    margin-left: 16px;
    margin-top: 8px;
  }
`;

export const FormContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  grid-area: form;
  min-width: 0;
`;

export const Form = styled.form`
  background: #221f3c;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 40px 32px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);

  @media screen and (max-width: 400px) {
    padding: 24px 16px; /* reduced for small screens */
  }
`;

export const FormH1 = styled.h1`
  color: #d3000d;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 30px;

  @media screen and (max-width: 400px) {
    padding-left: 0px;
  }
  @media screen and (max-width: 768px) {
    padding-left: 0px;
  }
`;

export const FormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  color: #fff;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 16px 16px;
  margin-bottom: 32px;
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
`;

export const FormButton = styled.button`
  background: #01bf71;
  padding: 16px 0;
  border: none;
  color: #fff;
  font-size: 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }
`;

export const Text = styled.span`
  text-align: center;
  margin-top: 24px;
  color: #fff;
  font-size: 14px;
`;

export const Description = styled.p`
  color: #fff;
  font-size: 20px;
  text-align: center;
  margin-bottom: 24px;
`;

export const FormLayout = styled.div`
  display: grid;
  gap: 32px;
  width: 100%;
  min-width: 0; /* allow shrink */
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-areas: "highlight form";
  align-items: stretch;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "form"
      "highlight";
  }
`;

export const HighlightCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: 36px 32px;
  border-radius: 24px;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(
    145deg,
    rgba(34, 31, 60, 0.9),
    rgba(17, 25, 40, 0.85)
  );
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 20px 35px rgba(5, 15, 50, 0.35);
  color: #fff;
  overflow: hidden;
  backdrop-filter: blur(18px);
  height: 100%;
  grid-area: highlight;
  min-width: 0;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
        circle at top right,
        rgba(3, 169, 244, 0.4),
        transparent 55%
      ),
      radial-gradient(
        circle at bottom left,
        rgba(211, 0, 13, 0.45),
        transparent 60%
      );
    opacity: 0.9;
    pointer-events: none;
  }
`;

export const HighlightInner = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  flex: 1;
`;

export const HighlightHeading = styled.h3`
  font-size: 16px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.75);
  white-space: normal; /* was nowrap */
  overflow-wrap: anywhere;
`;

export const HighlightBadge = styled.span`
  align-self: flex-start;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  background: rgba(3, 169, 244, 0.18);
  border: 1px solid rgba(3, 169, 244, 0.35);
  color: #8bd4ff;
`;

export const HighlightMetrics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const MetricBlock = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  padding: 16px 20px;
  display: flex;
  align-items: baseline;
  gap: 16px;
  justify-content: space-between;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
`;

export const MetricLabel = styled.span`
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
  text-align: right;
  flex: 1;
`;

export const MetricValue = styled.span`
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #fff;
`;

export const HighlightFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  margin-top: auto;
`;

export const HighlightFooterList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
`;

export const HighlightFootnote = styled.p`
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`;

export const HighlightFooterItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 13px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
  letter-spacing: 0.01em;

  &::before {
    content: ${(props) => (props.$isQuote ? '"\\201C"' : '"•"')};
    color: ${(props) =>
      props.$isQuote
        ? "rgba(139, 212, 255, 1)"
        : "rgba(139, 212, 255, 0.9)"};
    font-size: ${(props) => (props.$isQuote ? "24px" : "18px")};
    line-height: 1;
    margin-top: ${(props) => (props.$isQuote ? "-2px" : "2px")};
  }
`;

export const HighlightQuote = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const HighlightQuoteText = styled.span`
  font-size: 14px;
  font-style: italic;
  color: #ffffff;
  letter-spacing: 0.01em;
`;

export const HighlightQuoteSource = styled.span`
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(139, 212, 255, 0.85);
`;

export const SuccessMessage = styled.p`
  color: green;
  text-align: center;
  font-size: 16px;
  margin: 20px;
`;

export const ErrorMessage = styled.p`
  color: red;
  text-align: center;
  font-size: 16px;
  margin: 20px;
`;

export const RecaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 100%;
  overflow: hidden;
`;
